module.exports = __webpack_public_path__ + "static/media/MarkerPredicGreen.41c5fd1e.svg";